<template>
  <div class="whole-view">
    <div class="all_checked" v-if="show_check">
       <div :class="{check: all_checked}" @click="handleCheck">{{!all_checked ? '一键选课' : '取消选课'}}</div>
    </div>
    <div class="course-arr">
      <div class="course-item" v-for="(item, index) in list" :key="index">
        <img :src="item.directory_img" alt="">
        <div>
          <h3>{{item.directory_name}}</h3>
          <span>授课老师：{{item.teacher_name}}</span>
          <span v-if="year != cuurrent_year">时长：{{ item.file_time | setTime }} 分钟</span>
          <span v-else>学时：{{ item.file_period }}</span>
          <template v-if="item.is_choose == 0">
            <div v-if="!item.is_select" @click="cut_select(item, index)">添加</div>
            <div :class="item.is_required == 1 ? 'btn disabled' : 'btn'" v-if="item.is_select" @click="cut_select(item, index)">{{item.is_required == 1 ? '已选' : '取消'}}</div>
          </template>
          <div :class="item.is_choose == 1 ? 'btn disabled' : 'btn'" v-else>已选</div>
        </div>
      </div>
    </div>
    <div class="footer-place-whole"></div>

    <div class="bottom-handle-pay-whole">
      <template>
        <div class="bottom-tips" v-if="Number(year) <= 2019">
          继续教育45学时，课程系统已选定
        </div>
        <div class="bottom-tips" v-else-if="Number(year) > 2019 && Number(year) < cuurrent_year">
          专科课目60学时，课程系统已选定
        </div>
        <div class="bottom-tips" v-else style="font-weight: bold">
          {{year == cuurrent_year ? '请选择课程，达到60学时及以上即可支付' : '请自由选择课程，达到2400分钟即可支付'}}
        </div>
      </template>

      <template v-if="Number(year) == cuurrent_year">
        <div class="bottom-tips">
          已选<span class="num">{{ directory_ids.length }}</span>门
        </div>
        <div class="bottom-tips" v-if="year == cuurrent_year">
          共<span class="num">{{file_period}}</span>学时
        </div>
        <div class="bottom-tips" v-else>
          共<span class="num">{{parseInt(file_time/60)}}</span>分钟
        </div>
      </template>
      
      <div class="total-price">
        共计：¥<span class="price">{{ course_price }}</span
        >元
      </div>
      <div class="pay-btn" v-if="Number(year) == cuurrent_year" :style="{'background-color': file_period < 60 ? '#aaa' : ''}" @click="handlePay">立即支付</div>
      <div class="pay-btn" v-else  @click="handlePay">立即支付</div>
    </div>

    <el-dialog
      title="支付方式"
      width="330px"
      top="30vh"
      :visible.sync="wayVisible"
      :center="true">
      <div class="pay_way">
        <div @click="pay_radio = 2">
          <img src="../../../assets/weixin2.png" alt="">
          <span>微信</span>
          <div :class="{checke: pay_radio == 2}"></div>
          </div>
          <div @click="pay_radio = 1">
          <img src="../../../assets/balance.png" alt="">
          <span>账号余额</span>
          <div :class="{checke: pay_radio == 1}"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="wayVisible = false;buy(pay_radio)">立即支付</el-button>
      </span>
    </el-dialog>

    <div
      class="wechat-pay-shell"
      @click.stop="clear_pay_timer()"
      v-if="show_wechat_pay">
      <div class="wechat-content" @click.stop="">
        <img
          src="@/assets/colse-icon.png"
          alt=""
          class="colse-btn"
          @click.stop="show_wechat_pay = false,clear_pay_timer"/>
        <div class="pay-tips">扫一扫付款 (元)</div>
        <div class="pay-price">￥{{ pay_money }}</div>
        <div class="pay-qrcode" @click.stop="show_wechat_pay = false">
          <div
            id="qrcode"
            ref="qrcode"
            style="width: 100%;height: 100%;"
          ></div>
        </div>
        <div class="pay-type">
          <img src="@/assets/weixin.png" alt="" class="wechat-pay-icon" />
          微信支付
        </div>
      </div>
    </div>

    <el-dialog
      title="温馨提示"
      width="600px"
      @close="onClose"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true"
      :show-close="false">
      <div class="wxts-dialog">
        <div>
          按省药监局要求：{{year}}年执业药师继续教育<span>专业科目60学时，计20学分</span>和<span>公需科目30学时，计10学分</span>必须完成。
        </div>
        <div>公需科目学习免费，每天不限学习时长！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisiblehint" width="30%" center>
      <div class="lswx-dialog">
        <h3>专属老师微信</h3>
        <p>快扫码添加你的专属老师微信</p>
        <img src="@/assets/teacher_wx.png" alt="" class="code" />
        <div>服务时间：周一至周五8:30～17；30</div>
      </div>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  name: "pharmacist-course",
  data() {
    return {
      course_id: 0, // 课程ID
      list: [], // 列表
      course_price: "0.00", // 价格
      directory_ids: [], // 选中课程id数组
      pay_money: "0.0", // 支付价格
      pay_timer: null, // 获取支付结果定时器
      file_time: 0, // 当前已选课程总时长
      file_period: 0, // 当前已选课程总学时
      pay_radio: 2, 
      wayVisible: false,
      show_wechat_pay: false,
      dialogVisible: false,
      dialogVisiblehint: false,
      all_checked: false,
      show_check: false,
      year: '',
      cuurrent_year: '',
    };
  },
  props: ['leixing'],
  filters: {
    setTime (value) {
      return Math.round(value/60)
    }
  },
  watch: {
    
  },
  created () {
    // console.log(this.year)
    // // this.get_course_list()
    // if (Number(this.year) == this.cuurrent_year) {
    //   this.show_check = true
    // }

    this.$nextTick(() => {
      let openNum = Number(localStorage.getItem('openNum')) || 0
      if (openNum != 2) {
        openNum++
        localStorage.setItem('openNum', openNum)
        this.dialogVisiblehint = true
      }
      this.init()
    })
  },
  beforeDestroy() {
    document.getElementById('app').onscroll = ()=>{}
    window.clearInterval(this.pay_timer);
  },
  methods: {
    init () {
      let w = document.getElementsByClassName('pharmacist-course-shell')[0].clientWidth
      document.getElementsByClassName('bottom-handle-pay-whole')[0].style.width = w + 'px'
      setTimeout(() => {
        // 设置宽度
        let w = document.getElementsByClassName('pharmacist-course-shell')[0].clientWidth
        document.getElementsByClassName('bottom-handle-pay-whole')[0].style.width = w + 'px'
        // 获取左边距
        let left = document.getElementsByClassName('pharmacist-course-shell')[0].offsetLeft

        // 获取占位元素距离可视窗口顶部的距离
        // 滚动的距离 = 可视窗口顶部距离页面顶部的距离
        // 占位元素距离页面顶部的距离-滚动的距离= 占位元素距离可视窗口顶部的距离（pt）
        let top = document.getElementById("app").scrollTop
        let pt = document.getElementsByClassName('footer-place-whole')[0].offsetTop
        pt = pt - top
        // 当pt大于(可视窗口高度-30)的距离时使元素悬浮
        if (pt > document.documentElement.clientHeight-50) {
          document.getElementsByClassName('bottom-handle-pay-whole')[0].style.position = 'fixed'
          document.getElementsByClassName('bottom-handle-pay-whole')[0].style.bottom = '30px'
          document.getElementsByClassName('bottom-handle-pay-whole')[0].style.left = left+'px'
          document.getElementsByClassName('bottom-handle-pay-whole')[0].style.margin = '0'
        }
        document.getElementById('app').onscroll = () => {
          let top = document.getElementById("app").scrollTop
          let pt = document.getElementsByClassName('footer-place-whole')[0].offsetTop
          pt = pt - top
          if (pt > document.documentElement.clientHeight-50) {
            let left = document.getElementsByClassName('pharmacist-course-shell')[0].offsetLeft
            document.getElementsByClassName('bottom-handle-pay-whole')[0].style.position = 'fixed'
            document.getElementsByClassName('bottom-handle-pay-whole')[0].style.bottom = '30px'
            document.getElementsByClassName('bottom-handle-pay-whole')[0].style.left = left+'px'
          } else if (pt < document.documentElement.clientHeight-50) {
            // 当pt小于(可视窗口高度-30)的距离时使元素固定
            document.getElementsByClassName('bottom-handle-pay-whole')[0].style.position = 'relative'
            document.getElementsByClassName('bottom-handle-pay-whole')[0].style.bottom = '0'
            document.getElementsByClassName('bottom-handle-pay-whole')[0].style.left = '0'
          }    
        }
      }, 500)
    },
    // 获取课程列表
    get_course_list(year, cuurrent_year) {
      this.year = year
      this.cuurrent_year = cuurrent_year
      if (Number(this.year) == this.cuurrent_year) {
        this.show_check = true
      }
      this.API.post("user/phar_in-get_phar_course", {
        
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        this.type_name = res.data.type_name;
        this.course_id = res.data.course_id;
        this.course_price = res.data.phar_course.course_price;
        let file_time = 0
        let file_period = 0
        let list = res.data.phar_course.phar_course_info
        for (let i = 0; i < list.length; i++) {
          if (list[i].is_required) {
            list[i].is_select = true;
            file_time = file_time + list[i].file_time
            file_period = file_period + list[i].file_period
          } else {
            list[i].is_select = false;
          }
          list[i].name = list[i].directory_name
          if (list[i].directory_name.indexOf('（上）') != -1) {
            list[i].name = list[i].directory_name.split("（上）")[0]
          }
          if (list[i].directory_name.indexOf('（下）') != -1) {
            list[i].name = list[i].directory_name.split("（下）")[0]
          }
        }
        this.file_time = file_time
        this.file_period = Math.round(file_period * 100) / 100
        this.list = list;
        this.sum();
      });
    },
    handleCheck () {
      this.all_checked = !this.all_checked
      for (let i in this.list) {
        if (this.list[i].is_default == 1) {
          this.list[i].is_select = this.all_checked
        }
      }
      this.sum(this.all_checked);
    },
    // 选择课程
    cut_select(item, index) {
      if (item.is_required) {
        return this.API.SMessage("必选课程,不可取消");
      }
      this.list[index].is_select = !this.list[index].is_select;
      for (let v of this.list) {
        if (v.name === this.list[index].name) {
          v.is_select = this.list[index].is_select
        }
      }
      let list = this.list
      this.list = []
      this.$nextTick(() => {
        this.list = list
        this.sum(this.list[index].is_select);
      })
    },
    // 计算学时
    sum(type) {
      this.directory_ids = [];
      let file_time = 0
      let file_period = 0
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].is_select) {
          this.directory_ids.push(this.list[i].directory_id);
          file_time = file_time + this.list[i].file_time
          file_period = file_period + this.list[i].file_period
        }
      }
      this.file_time = this.file_time
      this.file_period = Math.round(file_period * 100) / 100
      if (this.year == this.cuurrent_year) {
        if (type && this.file_period >= 60) {
          this.$alert('您的选课已达到60学时，请立即支付!', '提示', {
            confirmButtonText: '确认',
            closeOnPressEscape: false,
            center: true,
            roundButton: true,
            confirmButtonClass: 'alertBtn',
            customClass: 'alertFont'
          });
          return
        }
      } else {
        if (type && this.file_time > 2400*60) {
          this.$alert('您的选课已达到2400分钟，请立即支付!', '提示', {
            confirmButtonText: '确认',
            closeOnPressEscape: false,
            center: true,
            roundButton: true,
            confirmButtonClass: 'alertBtn',
            customClass: 'alertFont'
          });
        }
      }
    },
    handlePay () {
      if (this.year == this.cuurrent_year) {
        if (this.file_period < 60) {
          this.$alert('您的选课未达到60学时，请继续选课！', '提示', {
            confirmButtonText: '确认',
            closeOnPressEscape: false,
            center: true,
            roundButton: true,
            confirmButtonClass: 'alertBtn',
            customClass: 'alertFont'
          });
          return
        }
      } else {
        if (this.file_time < 2400*60 && Number(this.year) == this.cuurrent_year) {
          this.$alert('您的选课未达到2400分钟，请继续选课！', '提示', {
            confirmButtonText: '确认',
            closeOnPressEscape: false,
            center: true,
            roundButton: true,
            confirmButtonClass: 'alertBtn',
            customClass: 'alertFont'
          });
          return
        }
      }
      this.wayVisible = true
    },
    // 购买, 提交订单
    buy(pay_way) {
      if (this.year == this.cuurrent_year) {
        if (this.file_period < 60) {
          this.$alert('您的选课未达到60学时，请继续选课！', '提示', {
            confirmButtonText: '确认',
            closeOnPressEscape: false,
            center: true,
            roundButton: true,
            confirmButtonClass: 'alertBtn',
            customClass: 'alertFont'
          });
          return
        }
      } else {
        if (this.file_time < 2400*60 && Number(this.year) == this.cuurrent_year) {
          this.$alert('您的选课未达到2400分钟，请继续选课！', '提示', {
            confirmButtonText: '确认',
            closeOnPressEscape: false,
            center: true,
            roundButton: true,
            confirmButtonClass: 'alertBtn',
            customClass: 'alertFont'
          });
          return
        }
      }
      this.API.post("user/phar_in-buy_phar_course", {
        course_id: this.course_id,
        directory_id: this.directory_ids.join(","),
        pay_way: pay_way,
        is_h5: 2,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        // if (res.errno == 0 && res.code == 1035) {
        //   this.API.SMessage("购买成功");
        //   this.$router.push("/personal");
        //   // return this.$router.push({ path: '/paymentOk?order_id=' + res.data.order_id })
        // }
        if (pay_way == 1) {
          this.$message({
            showClose: true,
            message: "购买成功",
            type: "success",
          });
          this.dialogVisible = true
          // if (this.year == this.cuurrent_year) {
          //   this.dialogVisible = true
          //   return;
          // }
          // this.$router.push('/personal')
          // this.$router.push({ path: "/paymentOk?order_id=" + res.data.order_id });
        } else {
          this.show_wechat_pay = true;
          this.pay_money = res.data.pay_money;
          setTimeout(() => {
            this.make(res.data.pay_info.pay_info.code_url);
            let order_id = res.data.order_id;
            if (order_id) {
              this.pay_timer = setInterval(() => {
                this.get_order_detail(order_id);
              }, 1000);
            } else {
              this.API.SMessage("后台未返回order_id");
            }
          }, 100);
        }
      });
    },
    // 生成二维码
    make (linkUrl) {
      this.$refs.qrcode.innerHTML = ""; // 防止重复生成
      let qrcode = new QRCode("qrcode", {
        width: 160,
        height: 160,
        text: linkUrl,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    // 定时获取获取支付结果,订单信息
    get_order_detail(order_id) {
      this.API.post("user/user_infos-order_detail", {
        order_id: order_id,
      }).then((res) => {
        if (res.errno != 0) {
          return this.API.SMessage(res.message);
        }
        if (res.data.order_info.order_status != "待付款") {
          window.clearInterval(this.pay_timer);
          this.$message({
            showClose: true,
            message: "购买成功",
            type: "success",
          });
          this.dialogVisible = true
          // if (this.year == this.cuurrent_year) {
          //   this.dialogVisible = true
          //   return;
          // }
          // this.$router.push('/personal')
          // this.$router.push({ path: "/paymentOk?order_id=" + order_id });
        }
      });
    },
    // 清除定时器
    clear_pay_timer() {
      this.show_wechat_pay = false;
      window.clearInterval(this.pay_timer);
    },
    // 弹窗关闭
    onClose () {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        if (res.data.state == 1) {
          this.$confirm('<div style="text-align:left">接省药监局通知,执业药师继续教育<span style="color:red">学习平台和报名通道</span>于2023年7月12日下午18:00起同步<span style="color:red">关闭进行系统升级</span>，预计下周同时开启。</div>', '温馨提示', {
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: false,
            confirmButtonText: '知道了',
          })
        } else {
          this.$router.push({ path: "/PublicList?year=" + this.year });
        }
      })
    },
  },
};
</script>

<style lang="less" scoped>
.whole-view {
  .all_checked {
    display: flex;
    justify-content: end;
    margin-bottom: 20px;
    > div {
      width: 120px;
      height: 45px;
      color: #fff;
      line-height: 45px;
      text-align: center;
      cursor: pointer;
      font-size: 20px;
      border: 1px solid #2aa9b5;
      background-color: #2aa9b5;
    }
    > .check {
      border: 1px solid #ff4050;
      background-color: #ff4050;
    }
  }
  .course-arr {
    display: flex;
    flex-wrap: wrap;
    .course-item {
      margin-bottom: 20px;
      display: flex;
      width: 30%;
      margin-right: 40px;
      > img {
        width: 160px;
        height: 160px;
        margin-right: 20px;
      }
      > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        h3 {
          font-size: 18px;
          font-weight: bold;
          color: #000000;
          white-space: pre-wrap;
          word-break: break-all;
          margin-bottom: 10px;
        }
        > span {
          margin-bottom: 10px;
          color: #666666;
        }
        > div {
          width: 130px;
          height: 30px;
          line-height: 30px;
          border-radius: 15px;
          border: 1px solid #2aa9b5;
          text-align: center;
          color: #2198a3;
          cursor: pointer;
          &:hover {
            background-color: rgb(48, 236, 253);
            color: #2198a3;
          }
        }
        .btn {
          background-color: #2aa9b5;
          color: #ffffff;
        }
        .disabled {
          border: #aaa;
          background-color: #aaa;
          &:hover {
            background-color: #aaa;
            color: #fff;
          }
        }
      }
    }
  }
  .bottom-handle-pay-whole {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 100px;
    border-radius: 50px;
    padding: 0 20px;
    background: #eeeeee;
    border: 1px solid #2198a3;

    .bottom-tips {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-right: 20px;
      .num {
        text-decoration: underline;
        display: inline-block;
        padding: 0 10px;
        color: red;
      }
    }

    .total-price {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      margin-right: 20px;
    }

    .pay-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      background: red;
      border-radius: 10px;
      font-size: 26px;
      font-family: PingFang SC;
      padding: 10px 15px;
      font-weight: bold;
      color: #ffffff;
      cursor: pointer;
    }

    .price,
    .num {
      color: rgba(216, 37, 28, 1);
      font-size: 34px;
    }
  }
}

.pay_way {
  padding: 0 10px;
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    cursor: pointer;
    border: 1px solid #ccc;
    padding: 10px 20px;
    border-radius: 5px;
    > img {
      width: 50px;
    }
    > span {
      flex: 1;
      margin: 0 10px;
    }
    &:last-child {
      margin-top: 30px;
    }
    > div {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid #ccc;
    }
    .checke {
      border: 7px solid #2aa9b5;
    }
  }
}

.wechat-pay-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;

  .wechat-content {
    position: relative;
    width: 710px;
    height: 592px;
    background-color: #fff;
    padding: 60px;

    .colse-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 24px;
      height: 24px;
    }

    .pay-tips {
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      text-align: center;
    }

    .pay-price {
      font-size: 40px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #d8251c;
      text-align: center;
      margin-top: 10px;
    }

    .pay-qrcode {
      width: 252px;
      height: 252px;
      border: 1px solid #eee;
      margin: 20px auto;
    }

    .pay-type {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #000000;

      .wechat-pay-icon {
        width: 34px;
        height: 30px;
        margin-right: 10px;
      }
    }
  }
}

/deep/ .el-dialog__title {
  font-size: 24px;
  color: #000000;
  font-weight: bold;
}

.wxts-dialog {
  span,
  > div {
    text-indent: 40px;
    font-size: 20px;
    line-height: 40px;
    color: #000000;
    span {
      color: red;
    }
  }
}

.lswx-dialog {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h3 {
    margin: 25px 0;
    font-size: 24px;
  }
  p {
    color: #666666;
    margin-bottom: 25px;
    font-size: 18px;
    text-align: center;
  }
  .code {
    width: 180px;
    margin: 0 0 40px;
  }
}
.el-dropdown-menu {
  border: 1px solid #30ecfd;
  > li {
    border-bottom: 1px solid #ccc;
  }
}
</style>
